<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <span v-text="$t('label.charge_by_receipt')"></span>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div>
                    <form v-for="(item, index) in items" :key="index" :id="`receipt_form_${index}`"
                          @submit.prevent="send($event, index)">
                        <div class="border in-border-header p-3 my-5">
                            <div class="section-header">
                                {{ `${$t('label.receipt_info')}  ${(index + 1)}` }}
                            </div>

                            <div class="section-body">
                                <kt-row class="mt-2">
                                    <kt-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <kt-form-group>
                                            <label for="receipt_type">{{ $t('label.receipt_type') }}</label>
                                            <select id="receipt_type" name="receipt_type" class="selected form-control"
                                                    v-model="item.receipt_type">
                                                <option v-for="(type, index) in receipt_types" :key="index"
                                                        :value="type.value">{{ type.title }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-row>
                            </div>

                            <div>
                                <kt-row class="mt-2">
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label :for="`amount`" v-text="$t('label.amount_rial')"></label>

                                            <amount-input
                                                :item_id="`amount`"
                                                :item_name="`amount`"
                                                :item="item"
                                            ></amount-input>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6"
                                            v-if="[
                                                walletTransactionType.CHARGE_BY_RECEIPT_FINALLY,
                                                 walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER
                                            ].includes(item.receipt_type)"
                                    >
                                        <kt-form-group>
                                            <label for="followup_code"
                                                   v-text="$t('money_request.followup_code')"></label>
                                            <input
                                                id="followup_code"
                                                name="followup_code"
                                                type="text"
                                                v-model="item.followup_code"
                                                class="form-control"
                                            >

                                        </kt-form-group>
                                    </kt-col>

                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6"
                                            v-if="[
                                                walletTransactionType.CHARGE_BY_RECEIPT_FINALLY,
                                                 walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER
                                            ].includes(item.receipt_type)"
                                    >
                                        <kt-form-group>
                                            <label for="bank_resource"
                                                   v-text="$t('label.bank_account_number')"></label>
                                            <select class="selected form-control" id="bank_resource"
                                                    name="bank_resource" v-model="item.bank_resource">
                                                <option v-for="(bank_account, index) in all_bank_accounts"
                                                        :key="index"
                                                        v-text="bank_account.number + ' (' + bank_account.bank_fa_name + ')'"
                                                        :value="bank_account.number">
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>

                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6"
                                            v-if="[
                                                walletTransactionType.CHARGE_BY_RECEIPT_FINALLY,
                                                 walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER
                                            ].includes(item.receipt_type)"
                                    >
                                        <kt-form-group>
                                            <label for="bank_id"
                                                   v-text="$t('pos.bank')"></label>
                                            <select name="bank_id" class="selected form-control" id="bank_id"
                                                    v-model="item.bank_id">
                                                <option :value="bankId.saderat" v-text="bankIdStr.get(bankId.saderat)">
                                                </option>
                                                <option :value="bankId.saman" v-text="bankIdStr.get(bankId.saman)">
                                                </option>
                                                <option :value="bankId.ayande" v-text="bankIdStr.get(bankId.ayande)">
                                                </option>
                                                <option :value="bankId.keshavarzi"
                                                        v-text="bankIdStr.get(bankId.keshavarzi)">
                                                </option>
                                                <option :value="bankId.parsian"
                                                        v-text="bankIdStr.get(bankId.parsian)">
                                                </option>
                                                <option :value="bankId.pasargad"
                                                        v-text="bankIdStr.get(bankId.pasargad)">
                                                </option>
                                                <option :value="bankId.melli"
                                                        v-text="bankIdStr.get(bankId.melli)">
                                                </option>
                                                <option :value="bankId.tejarat"
                                                        v-text="bankIdStr.get(bankId.tejarat)">
                                                </option>
                                                <option :value="bankId.mellat"
                                                        v-text="bankIdStr.get(bankId.mellat)">
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6"
                                        v-if="[
                                            walletTransactionType.CHARGE_BY_RECEIPT_FINALLY,
                                             walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER
                                        ].includes(item.receipt_type)"
                                    >
                                        <kt-form-group>
                                            <kt-form-label for="payment_date">
                                              {{ $t('label.payment_date') }}
                                            </kt-form-label>
                                            <button id="reset_payment_date"
                                                    @click="clearPaymentDate(index)"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                              <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                input-class="form-control"
                                                id="payment_date"
                                                name= "payment_date"
                                                v-model="item.payment_date"
                                                type="datetime"
                                                required
                                            />
                                          </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="7" lg="7" xl="7">
                                        <kt-form-group>
                                            <label for="has_receipt_file"
                                                   class="mb-1" v-text="$t('label.should_reduce_wallet_charge_wage')"></label>
                                            <br>
                                            <label class="switch m-0 mr-2 ml-2">
                                                <input id="has_receipt_file"
                                                       name="has_receipt_file"
                                                       v-model="item.enable_wage"
                                                       @change="changeStatus($event, item.enable_wage, index)"
                                                       type="checkbox">
                                                <span class="slider round"></span>
                                            </label>

                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6"
                                        v-if="[
                                             walletTransactionType.CHARGE_BY_RECEIPT_FINALLY,
                                             walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER
                                        ].includes(item.receipt_type)"
                                    >
                                        <kt-form-group>
                                            <label for="receipt_file"
                                                   v-text="$t('label.receipt_image_upload')"></label>
                                            <input
                                                type="file"
                                                :ref="`receipt_file${index}`"
                                                id="receipt_file"
                                                name="receipt_file"
                                                class="form-control"
                                                @change="onFileChange($event, index)"
                                            >

                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6" v-if="url[index]">
                                        <div id="preview">
                                            <div class="border rounded-lg p-3 img-thumbnail">
                                                <button type="button" @click="removeImg(index)"
                                                        style="position: absolute"
                                                        class="btn btn-danger btn-sm btn-icon rounded-pill"><span
                                                    class="fa fa-window-close"></span></button>
                                                <img v-if="url[index]" :src="url[index]"/>
                                            </div>
                                        </div>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="12" lg="12" xl="12" class="mb-2">
                                        <label for="description"
                                               v-text="$t('label.description')"></label>
                                        <textarea id="description" rows="4" name="description" class="form-control"
                                                  v-model="item.description"></textarea>

                                    </kt-col>
                                </kt-row>

                                <kt-row class="mt-1 mr-1  justify-content-md-end">
                                    <button class="btn btn-success" :id="`submit_btn_${index}`">
                                        <kt-icon name="plus"></kt-icon>
                                        <span v-text="$t('label.register')"></span>
                                    </button>
                                    <button :disabled="items.length === 1" @click="deleteItem(index)" type="button"
                                            class="btn btn-danger ml-2">
                                        <i class="fa fa-trash"></i>
                                        <span v-text="$t('label.delete')"></span>
                                    </button>
                                </kt-row>
                            </div>
                        </div>
                    </form>
                    <button @click="addItem" class="btn btn-primary" v-text="$t('label.add_new_record')"></button>
                </div>
            </kt-panel-body>
        </kt-panel>

    </main-content>
</template>

<script>
import MainContent from "@/components/main-content.vue";
import AmountInput from "@/components/custom-elements/amount-input";
import $ from 'jquery';
import {walletService} from "@/common/api.service";
import {KTApp} from '@/plugins/core/app'
import {i18n} from "@/plugins/i18n";
import {bankId, bankIdStr} from "@/constants/bankId";
import {walletTransactionType} from "@/constants/walletTransactionType";

export default {
    name: "ChargeByReceipt",
    computed: {
        walletTransactionType() {
            return walletTransactionType
        },
        bankIdStr() {
            return bankIdStr
        },
        bankId() {
            return bankId
        },
        slug() {
            return this.$route.params.slug;
        },
        fetchStarshop() {
            return this.slug === 'starshop';
        }
    },
    props: ['hashid'],
    components: {MainContent, AmountInput},

    data() {
        return {
            items: [
                {
                    amount: 0,
                    receipt_file: '',
                    followup_code: '',
                    has_receipt_file: false,
                    description: '',
                    receipt_type: null,
                    enable_wage: false,
                    bank_id: '',
                    payment_date: '',
                    bank_resource: '',
                }
            ],
            url: {},
            file_status: {},
            receipt_types: [
                {title: i18n.t('label.final_receipt'), value: walletTransactionType.CHARGE_BY_RECEIPT_FINALLY},
                {title: i18n.t('label.simple_receipt'), value: walletTransactionType.CHARGE_BY_RECEIPT},
                {
                    title: i18n.t('label.affiliate_marketer'),
                    value: walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER
                },
            ],
            all_bank_accounts: [],

        }
    },
    mounted() {
        const getBankAccounts = this.fetchStarshop
                ? walletService.getStarShopAllWalletBankAccountNumbers
                : walletService.getAllWalletBankAccountNumbers;

        getBankAccounts().then(res => {
            this.all_bank_accounts = res.data;
        });
    },

    methods: {
        clearPaymentDate(index) {
            if (this.items[index].payment_date) {
                this.items[index].payment_date = null;
            }
        },
        removeImg(index) {
            this.items[index].receipt_file = null;
            this.url[index] = null;
            this.items[index].receipt_file = null;
            this.$refs['receipt_file' + index][0].value = null;
            this.$forceUpdate()
        },
        changeStatus(event, value, index) {
            this.$forceUpdate();
        },
        addItem() {
            this.items.push({
                amount: 0,
                receipt_file: '',
                followup_code: '',
                has_receipt_file: false,
                description: '',
                receipt_type: null,
                enable_wage: false,
                payment_date: null
            })
        },

        deleteItem(index) {
            if (this.items.length > 1) {
                this.items.splice(index, 1)
                this.url[index] = null;
                this.file_status[index] = !this.file_status[index];
                this.$refs['receipt_file' + index][0].value = null;
                this.items[index] = {
                    amount: 0,
                    receipt_file: '',
                    followup_code: '',
                    has_receipt_file: false,
                    description: '',
                    receipt_type: null,
                    enable_wage: false,
                    payment_date: ''

                }
                this.$forceUpdate();
            }
        },


        onFileChange(e, index) {
            const file = e.target.files[0];
            this.url[index] = URL.createObjectURL(file);

            this.items[index].receipt_file = file

            this.$forceUpdate();
        },


        send(e, index) {
            let form = $(`#receipt_form_${index}`);
            let btn = $(`#submit_btn_${index}`);
            form.validate().resetForm();

            form.validate({
                rules: {
                    amount1: {
                        required: true,
                        min: 5,
                    }
                }
            })

            if (!form.valid()) {
                return false;
            }


            let formData = new FormData();

            formData.append(`amount`, this.items[index].amount)
            formData.append(`description`, this.items[index].description)
            formData.append(`enable_wage`, this.items[index].enable_wage)
            formData.append(`receipt_type`, this.items[index].receipt_type)
            formData.append(`payment_date`, this.items[index].payment_date)

            if ([
                  walletTransactionType.CHARGE_BY_RECEIPT_FINALLY,
                  walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER
            ].includes(this.items[index].receipt_type)) {
                formData.append(`receipt_file`, this.items[index].receipt_file)
                formData.append(`bank_id`, this.items[index].bank_id)
                formData.append(`bank_resource`, this.items[index].bank_resource)
                formData.append(`followup_code`, this.items[index].followup_code)
            }

            KTApp.progress(btn)

            const chargeByReceipt = this.fetchStarshop
                ? walletService.chargeStarShopByReceipt
                : walletService.chargeByReceipt;

            chargeByReceipt(this.hashid, formData).then((response) => {
                this.toastr.success(response.data.message)


            }).catch(({response}) => {
                if (response.status === 400)
                    form.validate().showErrors(response.data.data)
                    this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })


        },

        configurationFile() {
            return {
                headers: {'Content-Type': 'multipart/form-data'},
                onUploadProgress: function (progressEvent) {
                    this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    this.$forceUpdate();
                }.bind(this)
            };
        },

    }
}
</script>

<style scoped>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
}

#preview img {
    max-width: 100%;
    max-height: 450px;
}

.slider {
    background-color: #757575;
}

.slider.round {
    border-radius: 100px;
}

.slider.round:before {
    border-radius: 100px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 43px;
    height: 19px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #575757;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 1px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}
</style>